import axios, { isAxiosError } from 'axios'
import router from '@/router'

const instance = axios.create({
	baseURL : '/api-local',
  headers: {
    'Content-Type': 'application/json',
	
  }
})

instance.interceptors.request.use((request) => {
  const admin = localStorage.getItem('admin')
    ? JSON.parse(localStorage.getItem('admin') || '')
    : null


	
  if (admin) {
    request.headers['Authorization'] = `Bearer ${admin.token}`
  }

  return request
})

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (isAxiosError(error)) {
      const isTwoFactorRequired =
        error.response?.status === 403 &&
        (error.response?.data?.code === 'TWO_FACTOR_REQUIRED' ||
          error.response?.data?.error === 'Two-factor authentication is required')

      if (isTwoFactorRequired) {
        const admin = localStorage.getItem('admin')
          ? JSON.parse(localStorage.getItem('admin') || 'null')
          : null

        if (admin) {
          localStorage.setItem(
            'admin',
            JSON.stringify({
              ...admin,
              two_factor_enabled: false
            })
          )
        }

        if (router.currentRoute.value.name !== 'admin-profile') {
          await router.push({ name: 'admin-profile' })
        }
      }
    }

    return Promise.reject(error)
  }
)

export default instance

/*

{
	"error": {
		"code": 100,
		"message": "Odoo Session Expired",
		"data": {
			"name": "odoo.http.SessionExpiredException",
			"debug": "Traceback (most recent call last):\n  File \"/usr/lib/python3/dist-packages/odoo/http.py\", line 624, in _handle_exception\n    return super(JsonRequest, self)._handle_exception(exception)\n  File \"/usr/lib/python3/dist-packages/odoo/http.py\", line 310, in _handle_exception\n    raise pycompat.reraise(type(exception), exception, sys.exc_info()[2])\n  File \"/usr/lib/python3/dist-packages/odoo/tools/pycompat.py\", line 14, in reraise\n    raise value\n  File \"/usr/lib/python3/dist-packages/odoo/addons/http_routing/models/ir_http.py\", line 460, in _dispatch\n    cls._authenticate(func.routing['auth'])\n  File \"/usr/lib/python3/dist-packages/odoo/addons/base/models/ir_http.py\", line 124, in _authenticate\n    getattr(cls, \"_auth_method_%s\" % auth_method)()\n  File \"/usr/lib/python3/dist-packages/odoo/addons/base/models/ir_http.py\", line 97, in _auth_method_user\n    raise http.SessionExpiredException(\"Session expired\")\nodoo.http.SessionExpiredException: Session expired\n",
			"message": "Session expired",
			"arguments": [
				"Session expired"
			],
			"exception_type": "internal_error",
			"context": {}
		}
	}
}
  
*/
